import React from 'react';
import Icon from 'components/AppIcon';

const ActionButtons = ({ isEditMode, isArabic, onSave, onCancel, onDelete }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
      <div className="flex-1 flex flex-col sm:flex-row gap-4">
        {/* Save Button */}
        <button
          onClick={onSave}
          className="flex-1 sm:flex-none inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors duration-200"
        >
          <Icon name="Save" size={20} className="mr-2" />
          {isEditMode 
            ? (isArabic ? 'حفظ التغييرات' : 'Save Changes')
            : (isArabic ? 'حفظ العميل' : 'Save Client')
          }
        </button>

        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className="flex-1 sm:flex-none inline-flex items-center justify-center px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
        >
          <Icon name="X" size={20} className="mr-2" />
          {isArabic ? 'إلغاء' : 'Cancel'}
        </button>
      </div>

      {/* Delete Button (only in edit mode) */}
      {isEditMode && (
        <button
          onClick={onDelete}
          className="inline-flex items-center justify-center px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors duration-200"
        >
          <Icon name="Trash2" size={20} className="mr-2" />
          {isArabic ? 'حذف العميل' : 'Delete Client'}
        </button>
      )}
    </div>
  );
};

export default ActionButtons;